/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useContext, useMemo, useState } from "react";
import Context from "../context/userContext";
import { Login } from "../service/login";
import Auth from "../utils/validateToken";

const COOKIE_NAME = "jwt";

// path "/" para que la cookie sea válida en toda la app (sin esto el navegador
// la ata al directorio donde se hizo login, p. ej. /login).
const COOKIE_OPTIONS = {
  path: "/",
  sameSite: "strict",
  secure:
    typeof window !== "undefined" && window.location.protocol === "https:",
};

export default function useUser() {
  const { cookies, setCookie, removeCookie } = useContext(Context);
  const [state, setstate] = useState({
    loading: false,
    error: false,
    message: "",
  });

  // Descifrar es costoso (AES): se hace una sola vez por valor de cookie
  // en lugar de una vez por cada campo leído.
  const session = useMemo(() => Auth.decode(cookies[COOKIE_NAME]), [
    cookies[COOKIE_NAME],
  ]);

  const login = useCallback(
    ({ email, password }) => {
      setstate({ loading: true, error: false, message: "" });
      Login({ email, password })
        .then((response) => {
          if (response.success) {
            setstate({ loading: false, error: false, message: "" });
            setCookie(COOKIE_NAME, Auth.encode(response), COOKIE_OPTIONS);
          } else {
            setstate({
              loading: false,
              error: true,
              message: response.message,
            });
            removeCookie(COOKIE_NAME, COOKIE_OPTIONS);
          }
        })
        .catch((err) => {
          setstate({
            loading: false,
            error: true,
            message: "No se pudo conectar con el servidor",
          });
          removeCookie(COOKIE_NAME, COOKIE_OPTIONS);
        });
    },
    [removeCookie, setCookie]
  );

  const logout = useCallback(() => {
    removeCookie(COOKIE_NAME, COOKIE_OPTIONS);
  }, [removeCookie]);

  return {
    isLoggedIn: session,
    user: session?.username ?? "",
    user_id: session?.user_id ?? "",
    user_rol: session?.rol ?? "",
    // El API devuelve la llave como user_email, no como email.
    user_email: session?.user_email ?? "",
    imagen: session?.imagen ?? "",
    cliente_id: session?.cliente_id ?? "",
    proveedor_id: session?.proveedor_id ?? "",
    token: session
      ? `${session.token_type} ${session.access_token}`
      : undefined,
    loading: state.loading,
    error: state.error,
    message: state.message,
    login,
    logout,
  };
}
